export default "__VITE_ASSET__BXVWYcf7__"